module.exports = __webpack_public_path__ + "files/5c4eb0fa3cbd7ca4ff62d954a4e1ba87.svg";